// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import GatsbyBackgroundImage from '../components/images/GatsbyBackgroundImage';
import LinkButton from '../components/LinkButton';

import './ActionBlock.scss';

export const query = graphql`
	fragment ActionBlockFragment on Ozk_pageContent {
		action_block {
			heading
			subheading
			button_link
			button_text
			background_image {
				...BynderImageFragment
			}
		}
	}
`;

export const ActionBlock_REFERENCES = ['action_block.background_image'];

/**
 * @typedef ActionBlockOptions
 * @property {string} heading
 * @property {string} subheading
 * @property {import('../components/LinkButton').ButtonOptions} button
 * @property {string} button_link
 * @property {string} button_text
 * @property {import('../CSTypes').BynderImageOptions[]} background_image
 * 
 * 
 * @typedef ActionBlockProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<ActionBlockOptions>} [options]
 */
/**  @type {import('~/types/React').ReactFC<ActionBlockProps>} */
const ActionBlock = ({ options }) => {
	if (!options?.background_image?.[0]) {
		throw new Error('Require background image for Action Block.');
	}

	return (
		<div className="container">
			<GatsbyBackgroundImage className="action-block-container" option={options.background_image?.[0]}>
				<div className="action-block-opacity-background">
					<h1 className="action-heading" {...options.$?.heading}>
						{options.heading}
					</h1>
					{options.subheading && (
						<h2 className="action-subheading" {...options.$?.subheading}>
							{options.subheading}
						</h2>
					)}
					<div className="link-container">
						<LinkButton
							{...options.$?.button_text}
							className="link-button"
							options={{
								button_link: options.button_link,
								button_style: 'primary',
								button_text: options.button_text,
								open_in_new_tab: false,
							}}
						/>
					</div>
				</div>
			</GatsbyBackgroundImage>
		</div>
	);
};

export default ActionBlock;
